import { Helmet } from "react-helmet-async";
import { isAppHost } from "../config/origins";

/**
 * HostSEO — host-aware indexing directive.
 *
 * The same SPA build is served on both linklane.io (marketing) and
 * app.linklane.io. Without this, the app host would serve identical marketing
 * pages → duplicate content + the app surface getting indexed. When we're on
 * the app host, emit a site-wide `noindex, nofollow` so only the marketing
 * origin (and docs) carry SEO weight. Inert on localhost/previews.
 *
 * Mounted once near the app root; individual marketing pages can still set
 * their own per-page tags (this is the default/baseline only on the app host).
 */
export default function HostSEO() {
  if (!isAppHost()) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
